<template>
  <div class="module-add">
    <div class="add-btn" @click="handleOpen">
      <i class="icon iconfont icon-tianjia"></i>
      添加
    </div>
    <el-dialog
      :visible.sync="visibleAddModuleDialog"
      width="955px"
      append-to-body
      :before-close="handleClose"
      custom-class="module-add-dialog"
    >
      <div class="module-type-list">
        <div
          class="module-type-item"
          v-for="(item, index) in moduleTypeList"
          :key="index"
          @click="handleAddModule(item.key)"
        >
          <div class="title">
            <span class="icon-box"></span>
            {{ item.name }}
          </div>
          <img class="img-bg" :src="item.imgBg" alt="" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import characterProfileBg from "@/assets/images/book-module-character-profile.png";
import characterInfoBg from "@/assets/images/book-module-character-info.png";
import fightInfoBg from "@/assets/images/book-module-fight-info.png";
import skillInfoBg from "@/assets/images/book-module-skill-info.png";
import weaponInfoBg from "@/assets/images/book-module-weapon-info.png";
import upgradeInfoBg from "@/assets/images/book-module-upgrade-info.png";
import materialInfoBg from "@/assets/images/book-module-material-info.png";
import audioInfoBg from "@/assets/images/book-module-audio-info.png";
import relationInfoBg from "@/assets/images/book-module-relation-info.png";
import tabInfoBg from "@/assets/images/book-module-tab-info.png";

export default {
  name: "ModuleAdd",

  data() {
    return {
      visibleAddModuleDialog: false,
      moduleTypeList: [
        {
          key: "tab-info",
          name: "角色图片模块",
          imgBg: tabInfoBg
        },
        {
          key: "zs-tab-info",
          name: "角色选择模块（ZS）",
          imgBg: tabInfoBg
        },
        {
          key: "character-profile",
          name: "角色档案模块",
          imgBg: characterProfileBg
        },
        {
          key: "character-info",
          name: "角色信息模块",
          imgBg: characterInfoBg
        },
        {
          key: "fight-info",
          name: "战斗信息模块",
          imgBg: fightInfoBg
        },
        {
          key: "skill-info",
          name: "技能信息模块",
          imgBg: skillInfoBg
        },
        {
          key: "weapon-info",
          name: "专武信息模块",
          imgBg: weaponInfoBg
        },
        {
          key: "upgrade-info",
          name: "升级突破模块",
          imgBg: upgradeInfoBg
        },
        {
          key: "material-info",
          name: "好感物品模块",
          imgBg: materialInfoBg
        },
        {
          key: "audio-info",
          name: "台词语音模块",
          imgBg: audioInfoBg
        },
        {
          key: "relation-info",
          name: "人物关系模块",
          imgBg: relationInfoBg
        }
      ]
    };
  },

  mounted() {},

  methods: {
    handleClose() {
      this.visibleAddModuleDialog = false;
    },
    handleOpen() {
      this.visibleAddModuleDialog = true;
    },
    handleAddModule(type) {
      this.handleClose();
      this.$emit("addModule", type);
    }
  }
};
</script>

<style lang="less" scoped>
.module-add {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 24px;
  background: rgba(255, 255, 255, 0.61);
  border-radius: 8px;
  margin: 12px 0;
  .add-btn {
    margin: 0 auto;
    width: 200px;
    height: 50px;
    border: 1px dotted #666;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    cursor: pointer;
    .icon {
      margin-right: 16px;
    }
  }
}
/deep/ .module-add-dialog {
  background: #e9f0f7;
}
.module-type-list {
  background: #e9f0f7;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .module-type-item {
    position: relative;
    width: 208px;
    height: 157px;
    border-radius: 8px;
    border: 1px dotted #727c86;
    cursor: pointer;
    margin-right: 25px;
    margin-bottom: 30px;
    &:nth-child(4n + 4) {
      margin-right: 0;
    }
    .img-bg {
      width: 100%;
      height: 100%;
    }
    .title {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 16px;
      font-weight: 500;
      color: #353535;
      line-height: 22px;
      padding: 8px 12px;
      .icon-box {
        display: inline-block;
        vertical-align: middle;
        width: 5px;
        height: 18px;
        background: #5e88e1;
        border-radius: 8px;
        margin-right: 9px;
      }
    }
  }
}
</style>
